import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class GlCodePayableColumn extends Column {
    title = 'payroll.deductions.glCodePayable';
    property = 'glCodePayable';
    type: CellDisplay = CellDisplay.string;
}
